<div class="dialog-wrapper">
  <div class="dialog-content" mat-dialog-content>
    <h2>Er du sikker på at du vil forlate siden?</h2>
    <p>All informasjonen du har lagt til om ny kunde vil bli slettet om du forlater siden</p>
  </div>
  <div class="dialog-actions" mat-dialog-actions>
    <app-ice-button color="outlined" testId="cancel-register-customer-dialog-button" (click)="abort()">
      Avbryt
    </app-ice-button>
    <app-ice-button
      color="secondary"
      matDialogClose
      testId="cancel-register-customer-button"
      (click)="confirmReset()"
    >
      Forlat siden
    </app-ice-button>
  </div>
</div>
